import classnames from 'classnames'
import React from 'react'

import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'
import ProductPageSectionProps from '@src/quince-site-pdp/src/domains/ProductPageSectionProps'

import { getSectionDetailsForDevices } from '../../../helper/product.helper'

import { Section } from './components/Section'
import { isRowOfImageTextBlocksSectionDataValid } from './rowOfImageTextBlocks.helpers'

function RowOfImageTextBlocks(props: ProductPageSectionProps | BundlePageSectionProps) {
  const product = 'bundle' in props ? props.bundle : props.product
  const { desktopSectionDetails, mobileSectionDetails } = getSectionDetailsForDevices(
    product,
    CUSTOM_SECTION_TYPE.ROW_OF_IMAGE_TEXT_BLOCKS,
  )

  return (
    <>
      {desktopSectionDetails && isRowOfImageTextBlocksSectionDataValid(desktopSectionDetails) && (
        <Section sectionDetails={desktopSectionDetails} containerClassName={classnames('desktopOnly')} />
      )}
      {mobileSectionDetails && isRowOfImageTextBlocksSectionDataValid(mobileSectionDetails) && (
        <Section sectionDetails={mobileSectionDetails} containerClassName={classnames('mobileOnly')} />
      )}
    </>
  )
}

export default RowOfImageTextBlocks
